module.exports = __webpack_public_path__ + "static/media/ic_add_ao.c7347074.svg";